export const home = '/';
export const about = '/about';
export const program = '/program';
export const contact = '/contact';
export const subscription = '/subscription';
export const signup = '/signup';